function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createStoreon = function createStoreon(modules) {
  var events = {};
  var state = {};
  var store = {
    dispatch: function dispatch(event, data) {
      if (event !== '@dispatch') {
        store.dispatch('@dispatch', [event, data, events[event]]);
      }

      if (events[event]) {
        var changes;
        events[event].forEach(function (i) {
          var diff = events[event].includes(i) && i(state, data, store);

          if (diff && typeof diff.then !== 'function') {
            state = _objectSpread(_objectSpread({}, state), diff);
            changes = _objectSpread(_objectSpread({}, changes), diff);
          }
        });
        if (changes) store.dispatch('@changed', changes);
      }
    },
    get: function get() {
      return state;
    },
    on: function on(event, cb) {
      ;
      (events[event] || (events[event] = [])).push(cb);
      return function () {
        events[event] = events[event].filter(function (i) {
          return i !== cb;
        });
      };
    }
  };
  modules.forEach(function (i) {
    if (i) i(store);
  });
  store.dispatch('@init');
  return store;
};

export { createStoreon };